import handler from 'api/handler';

const prefix = '/admin/spirituality';

const methods = {
  addSpirituality: args => handler({ method: 'post', url: prefix + '/add', args }),
  updateSpirituality: args => handler({ method: 'put', url: prefix + '/update', args }),
  fetchAllSpirituality: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  deleteSpirituality: id => handler({ method: 'delete', url: `${prefix}/delete/${id}` }),
};

export default methods;
